import { getDay as fnsGetDay } from 'date-fns'
import { parseDate } from '../parseDate'

const weekdays = ['日', '月', '火', '水', '木', '金', '土']

export const getDayInJa = (dateStr: string, format: 'short' | 'middle' | 'long' = 'short'): string => {
  const parsedDate = parseDate(dateStr)
  if (!parsedDate) {
    throw new Error('Invalid date string')
  }
  return `${weekdays[fnsGetDay(parsedDate)]}${format === 'short' ? '' : format === 'middle' ? '曜' : '曜日'}`
}
